"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventEmitter = void 0;
/**
 * Create event emitter.
 *
 * ```js
 * import { EventEmitter } from '@oneaudi/oneaudi-os-utils'
 *
 * class Ticker {
 *   constructor() {
 *     this.emitter = new EventEmitter()
 *   }
 *   on(...args) {
 *     return this.emitter.on(...args)
 *   }
 *   tick() {
 *     this.emitter.emit('tick')
 *   }
 * }
 * ```
 */
var EventEmitter = /** @class */ (function () {
    function EventEmitter() {
        /**
         * Event names in keys and arrays with listeners in values.
         *
         * ```js
         * emitter1.events = emitter2.events
         * emitter2.events = { }
         * ```
         */
        this.events = {};
    }
    /**
     * Add a listener for a given event.
     *
     * ```js
     * const unbind = ee.on('tick', (tickType, tickDuration) => {
     *   count += 1
     * })
     *
     * disable () {
     *   unbind()
     * }
     * ```
     *
     * @param event The event name.
     * @param cb The listener function.
     * @returns Unbind listener from event.
     */
    EventEmitter.prototype.on = function (event, cb) {
        var _this = this;
        var _a;
        this.events[event] = this.events[event] || [];
        (_a = this.events[event]) === null || _a === void 0 ? void 0 : _a.push(cb);
        return function () {
            var _a;
            return (_this.events[event] = (_a = (_this.events[event] || [])) === null || _a === void 0 ? void 0 : _a.filter(function (callback) { return callback !== cb; }));
        };
    };
    /**
     * Calls each of the listeners registered for a given event.
     *
     * ```js
     * ee.emit('tick', tickType, tickDuration)
     * ```
     *
     * @param event The event name.
     * @param args The arguments for listeners.
     */
    EventEmitter.prototype.emit = function (event) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var callbacks = this.events[event];
        if (Array.isArray(callbacks)) {
            callbacks.forEach(function (callback) { return callback.apply(void 0, args); });
        }
    };
    return EventEmitter;
}());
exports.EventEmitter = EventEmitter;
